import React from 'react';
import PropTypes from 'prop-types';
import { PrimeProvider, useGetUserQuery } from '@edreamsodigeo/frontend-flights-results';
import { usePrimeSitePropertiesQuery, useMembershipAccountPropertiesQuery, PrimeSubscriptionModalUIProviderFunction } from '@edreamsodigeo/frontend-prime';
const PrimeResultsProvider = ({
  children
}) => {
  const {
    data: primeSiteProperty,
    loading: primeSitePropertyLoading,
    errors: primeSitePropertyError
  } = usePrimeSitePropertiesQuery();
  const {
    data: userData,
    loading: userLoading,
    error: userError
  } = useGetUserQuery();
  const userEmail = !userLoading && !userError && userData?.getUser?.email || '';
  const {
    data: dataPrimeUser
  } = useMembershipAccountPropertiesQuery(userEmail);
  const primeSitePropertySuccess = !primeSitePropertyLoading && !(primeSitePropertyError && primeSitePropertyError.length > 0);
  const userDataSuccess = !userLoading && !userError;
  const primeProviderProps = {
    primeSitePropertySuccess,
    primeSiteProperty,
    userDataSuccess,
    dataPrimeUser
  };
  return /*#__PURE__*/React.createElement(PrimeSubscriptionModalUIProviderFunction, null, /*#__PURE__*/React.createElement(PrimeProvider, primeProviderProps, children));
};
PrimeResultsProvider.propTypes = {
  children: PropTypes.node.isRequired
};
export default PrimeResultsProvider;